import {
    UPDATE_POST_COUNTS_AFTER_COMMENT_RELEVANCE_UPDATED,
    ALL
} from './constants';
import {
    getThreeClassSentimentCategory
} from '../../shared-components/chart/redux/updateChartForRelevanceUpdatesOfCommentOrTweetService';
import {
    isCommentInFeedModal
} from './updatePostCountsForToggledSarcasticComment';
import { SARCASM_THRESHOLD, IS_SARCASM_ENABLED } from '../../../common/globalConstants';

const CATEGORY_KEY                    = "category";
const TOTAL_KEY                       = "total";
const SCORE_KEY                       = "score";
const IS_SARCASM_MANUALLY_TOGGLED_KEY = "isSarcasmManuallyToggled";

export function updatePostCountsForCommentRelevanceUpdates(commentAfterRelevanceUpdates) {
    return dispatch => {
        dispatch({
            type: UPDATE_POST_COUNTS_AFTER_COMMENT_RELEVANCE_UPDATED,
            data: {
                commentAfterRelevanceUpdates: commentAfterRelevanceUpdates
            }
        });
    };
}

export function reducer(state, action) {
    if (action.type !== UPDATE_POST_COUNTS_AFTER_COMMENT_RELEVANCE_UPDATED) {
        return state;
    }
    if (!state) {
        return state;
    }
    const { commentAfterRelevanceUpdates } = action.data;
    
    const feedId = commentAfterRelevanceUpdates.feedId;
    const relevance = commentAfterRelevanceUpdates.relevance;
    const emotionCategory   = commentAfterRelevanceUpdates.emotion.category;
    const sentimentCategory = commentAfterRelevanceUpdates.sentiment.category;
    const threeClassSentimentCategory  = getThreeClassSentimentCategory(sentimentCategory);

    const updatedFeeds = state.allFeeds.data.map(feed => {
        if (feed.feedId === String(feedId)) {
            feed = updatePostRelevantCommentCount(
                feed,
                relevance
            );
            feed = updatePostSentimentCounts(
                feed,
                relevance,
                threeClassSentimentCategory
            );
            feed = updatePostEmotionCounts(
                feed,
                relevance,
                emotionCategory
            );
            if (IS_SARCASM_ENABLED) {
                feed = updatePostSarcasticCommentCount(
                    feed,
                    relevance,
                    commentAfterRelevanceUpdates
                );
            }
        }
        return feed;
    });
    state.allFeeds.data = updatedFeeds;

    state = updateFeedModalFilteredCommentCounts(
        state,
        relevance,
        commentAfterRelevanceUpdates,
        threeClassSentimentCategory,
        emotionCategory
    );
    return state;
}

export function updatePostRelevantCommentCount(
    feed,
    relevance
) {
    if (relevance) {
        feed.relevantCommentCount += 1;
    }
    else {
        feed.relevantCommentCount -= 1;
    }
    return feed;
}

export function updatePostSentimentCounts(
    feed,
    relevance,
    threeClassSentimentCategory
) {
    const newSentimentCounts = [...feed.sentiment]
    for (const sentiment of newSentimentCounts) {
        if (sentiment[CATEGORY_KEY] === threeClassSentimentCategory) {
            if (relevance) {
                sentiment[TOTAL_KEY] += 1;
            }
            else {
                sentiment[TOTAL_KEY] -= 1;
            }
        }
    }
    feed.sentiment = newSentimentCounts;
    return feed;
}

export function updatePostEmotionCounts(
    feed,
    relevance,
    emotionCategory
) {
    const newEmotionCounts = {...feed.emotionCounts}
    if (relevance){
        newEmotionCounts[emotionCategory] += 1;
    }
    else {
        newEmotionCounts[emotionCategory] -= 1;
    }
    feed.emotionCounts = newEmotionCounts;
    return feed;
}

export function updatePostSarcasticCommentCount(
    feed,
    relevance,
    commentAfterRelevanceUpdates
) {
    const isCommentSarcastic = checkIfCommentIsSarcastic(commentAfterRelevanceUpdates);
    if (!isCommentSarcastic) {
        return feed;
    }

    if (relevance) {
        feed.sarcasticCommentCount += 1;
    }
    else {
        feed.sarcasticCommentCount -= 1;
    }
    return feed;
}

export function checkIfCommentIsSarcastic(commentAfterRelevanceUpdates){
    let isCommentSarcastic = false;
    if (!commentAfterRelevanceUpdates.sarcasm) {
        return isCommentSarcastic;
    }

    if ((commentAfterRelevanceUpdates.sarcasm[SCORE_KEY] >= SARCASM_THRESHOLD && !commentAfterRelevanceUpdates.sarcasm[IS_SARCASM_MANUALLY_TOGGLED_KEY])
        || (commentAfterRelevanceUpdates.sarcasm[SCORE_KEY] < SARCASM_THRESHOLD && commentAfterRelevanceUpdates.sarcasm[IS_SARCASM_MANUALLY_TOGGLED_KEY])) {
        
        isCommentSarcastic = true;
    }
    return isCommentSarcastic;
}

export function updateFeedModalFilteredCommentCounts(
    state,
    relevance,
    commentAfterRelevanceUpdates,
    threeClassSentimentCategory,
    emotionCategory
) {
    if (isCommentInFeedModal(state, commentAfterRelevanceUpdates) && state.feedDetails.filteredCommentCounts) {
        const newFilteredCommentCounts = {...state.feedDetails.filteredCommentCounts}
        if (relevance) {
            newFilteredCommentCounts[ALL] += 1;
            newFilteredCommentCounts[threeClassSentimentCategory] += 1;
            newFilteredCommentCounts[emotionCategory] += 1;
        }
        else {
            newFilteredCommentCounts[ALL] -= 1;
            newFilteredCommentCounts[threeClassSentimentCategory] -= 1;
            newFilteredCommentCounts[emotionCategory] -= 1;
        }
        state.feedDetails.filteredCommentCounts = newFilteredCommentCounts;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/features/home/redux/updatePostCountsForCommentRelevanceUpdates.js